import Button from '../common/Button.js';
import { QrCode } from 'lucide-react';
import { useScanQrModal } from '../../context/ScanQrModalContext.js';
import { useAuth } from '../../context/AuthContext.js';
import { canOpenScanQrModal } from '../../utils/networkMode.js';


const ScanQrStatusButton = ({
  variant = 'secondary',
  className = '',
  label = 'Scan QR',
  fullWidth = false,
  mobileIconOnly = false,
}) => {
  const { user } = useAuth();
  const { openScanQrModal } = useScanQrModal();

  if (!canOpenScanQrModal(user)) return null;

  return (
    <Button
      variant={variant}
      icon={QrCode}
      onClick={openScanQrModal}
      className={className}
      fullWidth={fullWidth}
      mobileIconOnly={mobileIconOnly}
      mobileLabel={label}
    >
      {label}
    </Button>
  );
};

export default ScanQrStatusButton;
